import Api from '@api/shou_xie/setMeal'
import { observable, runInAction } from 'mobx'

class Store {
  @observable propertyList = []

  constructor(type = 0) {
    this.type = type
  }

  getPropertyList = async () => {
    const {
      data: { list }
    } = await Api.mealProperties({
      commodity_type: this.type
    })

    runInAction(() => {
      this.propertyList = (list || []).filter(item => item.id != 1)
    })
  }
}

export default Store
